const CITIES = [
  "Perth",
  "Darwin",
  "Brisbane",
  "Sydney",
  "Canberra",
  "Melbourne",
  "Adelaide",
  "Hobart",
];

const CENTER = 100;
const NODE_RADIUS = 78;

function nodePosition(index: number, total: number) {
  const angle = (index / total) * Math.PI * 2 - Math.PI / 2;
  return {
    x: CENTER + Math.cos(angle) * NODE_RADIUS,
    y: CENTER + Math.sin(angle) * NODE_RADIUS,
  };
}

/**
 * Abstract national coverage network: one hub, pulsing lines out to every
 * state and territory capital. Deliberately not a literal map (a hand-drawn
 * coastline at this size reads as an unrecognisable blob); a radiating
 * network reads clearly and matches the site's live-ledger/data motif.
 */
export function CoverageMap({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 200 200"
      className={className}
      role="img"
      aria-label="NextEra serves clients in every Australian state and territory"
    >
      {CITIES.map((city, i) => {
        const { x, y } = nodePosition(i, CITIES.length);
        return (
          <line
            key={`line-${city}`}
            x1={CENTER}
            y1={CENTER}
            x2={x}
            y2={y}
            stroke="var(--electric)"
            strokeOpacity={0.3}
            strokeWidth={1}
          />
        );
      })}
      {CITIES.map((city, i) => {
        const { x, y } = nodePosition(i, CITIES.length);
        return (
          <g key={city}>
            <circle cx={x} cy={y} r={6} fill="var(--electric)" opacity={0.18}>
              <animate
                attributeName="r"
                values="6;11;6"
                dur="2.4s"
                begin={`${i * 0.22}s`}
                repeatCount="indefinite"
              />
              <animate
                attributeName="opacity"
                values="0.22;0;0.22"
                dur="2.4s"
                begin={`${i * 0.22}s`}
                repeatCount="indefinite"
              />
            </circle>
            <circle cx={x} cy={y} r={2.6} fill="var(--electric)" />
            <title>{city}</title>
          </g>
        );
      })}
      <circle
        cx={CENTER}
        cy={CENTER}
        r={10}
        fill="var(--navy)"
        stroke="var(--electric)"
        strokeWidth={1.5}
      />
      <circle cx={CENTER} cy={CENTER} r={3} fill="var(--electric)" />
    </svg>
  );
}
